import datapoints from '../datapoints';
import { ComposeOperation, ComposeTarget, ComposeViewStateInitProps } from 'owa-mail-compose-store';
import getDefaultBodyType from 'owa-mail-compose-actions/lib/utils/getDefaultBodyType';
import { lazyOpenCompose } from 'owa-mail-compose-actions';
import { onNewMessage } from 'owa-mail-module-orchestrator';
import type { ActionSource } from 'owa-mail-store';
import type Item from 'owa-service/lib/contract/Item';
import { returnTopExecutingActionDatapoint, wrapFunctionForDatapoint } from 'owa-analytics';
import { getGuid } from 'owa-guid';
import type EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import { getCurrentGroupSmtpAddress } from 'owa-groups-shared-store/lib/selectors/getCurrentGroupSmtpAddress';
import { getGroupDisplayName } from 'owa-group-utils/lib/utils/getGroupDisplayName';
import isSendAsPermissionEnabled from 'owa-mail-compose-actions/lib/utils/sendAsOnBehalfOfGroups';
import { isGroupSelected } from 'owa-group-utils';
import { isGroupsEnabled } from 'owa-account-capabilities/lib/isGroupsEnabled';
// Load options now to retrieve emoji skin tone options before expression pane is opened
import 'owa-outlook-service-options';
import { isDeepLink } from 'owa-url';

export default wrapFunctionForDatapoint(datapoints.MailComposeNew, async function newMessage(
    actionSource: ActionSource,
    targetId?: string, //target maybe group or public folder
    toEmailAddressWrappers?: EmailAddressWrapper[],
    subject?: string,
    body?: string,
    isPopout?: boolean,
    mailItems?: Item[] //in case the new message needs email list items as attachments
) {
    const openTarget = isPopout
        ? ComposeTarget.Popout
        : !isDeepLink()
        ? ComposeTarget.SecondaryTab
        : ComposeTarget.PrimaryReadingPane;

    const bodyType = getDefaultBodyType();
    const toRecipients = [];

    if (toEmailAddressWrappers) {
        toRecipients.push(...toEmailAddressWrappers);
    }

    const logTraceId = getGuid();
    const newMessageDatapoint = returnTopExecutingActionDatapoint();
    // Datapoint is not present for unit tests
    if (newMessageDatapoint) {
        newMessageDatapoint.addCustomData({
            composeTraceId: logTraceId,
            actionSource: actionSource,
        });
    }

    const isInGroupsView = isGroupsEnabled() && isGroupSelected();
    const groupId = isInGroupsView ? getCurrentGroupSmtpAddress() : null;
    const doNotPopulateToField = actionSource === 'CommandBar';

    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2345 (59,48): Argument of type 'string | null' is not assignable to parameter of type 'string'.
    // @ts-expect-error
    const fromData = isSendAsPermissionEnabled(groupId)
        ? {
              EmailAddress: groupId,
              // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
              // -> Error TS2345 (65,41): Argument of type 'string | null' is not assignable to parameter of type 'string'.
              // @ts-expect-error
              Name: getGroupDisplayName(groupId),
              RoutingType: 'SMTP',
              MailboxType: 'GroupMailbox',
          }
        : null;

    const composeInitProps: ComposeViewStateInitProps = {
        operation: ComposeOperation.New,
        bodyType: bodyType,
        to: toRecipients,
        preferAsyncSend: true,
        subject: subject,
        newContent: body,
        logTraceId: logTraceId,
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (82,9): Type '{ EmailAddress: string | null; Name: string; RoutingType: string; MailboxType: string; } | null' is not assignable to type 'EmailAddressWrapper | undefined'.
        // @ts-expect-error
        from: fromData,
        doNotPopulateToField: doNotPopulateToField,
        mailItems: mailItems,
    };

    await lazyOpenCompose.importAndExecute(
        composeInitProps,
        openTarget,
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2345 (93,9): Argument of type 'null' is not assignable to parameter of type 'Window | undefined'.
        // @ts-expect-error
        null /*targetWindow*/,
        targetId
    );
    onNewMessage(openTarget === ComposeTarget.SecondaryTab || openTarget === ComposeTarget.Popout);
});
